import { ROUTES } from '@shared/utils';
import { browse, discover, offers, purchases } from '../../tabs/tabs';
import type { ProductNavigationConfig, SectionMatcher } from '../../types';

const { DISCOVERY, PURCHASES, BROWSE, OFFERS } = ROUTES.LOTTO;

const lotteriesNavigation: ProductNavigationConfig = {
  navigationTabs: [
    { ...discover, href: DISCOVERY },
    { ...browse, href: BROWSE },
    { ...purchases, href: PURCHASES },
    { ...offers, href: OFFERS },
  ],
  sectionMatchers: [
    [`^${PURCHASES}(/.*)?$`, 'purchases'],
    [`^${OFFERS}(/.*)?$`, 'offers'],
    [`^${DISCOVERY}/.*$`, 'browse'],
    [`^${DISCOVERY}`, 'discover'],
  ] as const satisfies SectionMatcher[],
  staticNavOnPages: [PURCHASES, OFFERS],
};

export { lotteriesNavigation };
